import { render, staticRenderFns } from "./LkInput.vue?vue&type=template&id=4c07a985&"
import script from "./LkInput.vue?vue&type=script&lang=js&"
export * from "./LkInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports